"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import "src/decidim/map/controller/markers";
import configStore from "./stores/configStore";
import pointStore from "./stores/pointStore";
import filterStore from "./stores/filterStore";
import pointCounterStore from "./stores/pointCounterStore";
import geoStore from "./stores/geoStore";
import memoryStore from "./stores/memoryStore";
import dropdownFilterStore from "./stores/dropdownFilterStore";
import { initMap, DrawerHeader, Drawer, aside } from "./ui";
import bootstrap from "./bootstrap";
import registerMobile from "./ui/mobile/registerMobile";
import FilterControl from "./ui/FilterControl";
import PageNameControl from "./ui/PageNameControl";
import L from "./leaflet";
import _ from "lodash";
window.debug = window.debug || {};
window.debug.stores = () => ({
  config: configStore.getState(),
  filter: filterStore.getState(),
  geo: geoStore.getState(),
  point: pointStore.getState(),
  dropdownFilter: dropdownFilterStore.getState(),
  memoryStore: memoryStore.getState(),
  pointCounterStore: pointCounterStore.getState()
});
function prepareLeaflet(isSmallScreen) {
  return __async(this, null, function* () {
    bootstrap();
    const { map, tile } = yield initMap();
    configStore.setState(() => ({ map, isSmallScreen }));
  });
}
function fetchData() {
  return __async(this, null, function* () {
    const { addProcess, removeProcess, fetchAll, pointsForFilters } = pointStore.getState();
    const { defaultFilters, activeFilters } = filterStore.getState();
    addProcess();
    yield Promise.all([fetchAll(defaultFilters), pointsForFilters(activeFilters)]);
    removeProcess();
  });
}
function displayMap() {
  return __async(this, null, function* () {
    var _a;
    try {
      const { addProcess, removeProcess } = pointStore.getState();
      const { moveHandler, setSavedPosition } = memoryStore.getState();
      const { map, pointsLayer, scopeLayer } = configStore.getState();
      addProcess();
      map.addLayer(scopeLayer);
      map.addLayer(pointsLayer);
      map.whenReady(() => __async(this, null, function* () {
        pointCounterStore.getState().updateCurrentCountForFilters(filterStore.getState().activeFilters);
        aside([DrawerHeader, Drawer]);
        map.addControl(new FilterControl());
        map.setMinZoom((configStore.getState().map_config.zoom || 15) - 2);
        yield new Promise((resolve) => setTimeout(resolve, 64));
        configStore.getState().setReady();
        removeProcess();
        setTimeout(setSavedPosition, 640);
      }));
      pointStore.subscribe(
        (state) => [
          !!state.isLoading,
          state.isInitialized,
          state.getFilteredPoints,
          state.fetchesRunning,
          state._lastResponse
        ],
        ([isLoading, isInitialized, getFilteredPoints, fetchesRunning]) => {
          if (isLoading > 0 || !isInitialized) {
            return;
          }
          const { map: map2, pointsLayer: pointsLayer2, isSmallScreen } = configStore.getState();
          const { selectedPoint, selectedScope } = geoStore.getState();
          const pointInMap = getFilteredPoints().filter(
            (node) => typeof node.isGeoLocated !== "undefined" && node.isGeoLocated()
          );
          pointsLayer2.clearLayers();
          if (pointInMap.length > 0) {
            pointInMap.forEach(({ marker }) => {
              marker.addTo(pointsLayer2);
            });
            const bounds = L.latLngBounds(
              pointInMap.map(({ marker }) => marker.getLatLng())
            );
            map2.fitBounds(bounds, {
              animate: true,
              padding: isSmallScreen ? [16, 16, 32, 16] : [32, 32, 32, 310],
              maxZoom: map2.getZoom()
            });
          } else {
            console.warn("DecidimGeo: No points in map?");
            return;
          }
          if (fetchesRunning === 0 && (selectedScope == null ? void 0 : selectedScope.layer) && selectedScope && !selectedPoint) {
            map2.setView(selectedScope.layer.getBounds().getCenter(), map2.getZoom(), {
              animation: true
            });
          }
        }
      );
      geoStore.subscribe(
        (state) => [state.selectedScope],
        ([geoScope]) => {
          const activeList = document.getElementsByClassName(
            "decidimGeo__drawerHeader__listItem--active"
          );
          for (const domEl of activeList) {
            domEl.className = domEl.className.replace("decidimGeo__drawerHeader__listItem--active", "").trim();
          }
          const [container] = document.querySelectorAll(".decidimGeo__drawerHeader__list");
          if (!container) return;
          if (geoScope == null ? void 0 : geoScope.id) {
            const [active2] = document.querySelectorAll(
              `.decidimGeo__drawerHeader__listItem[data-scope='${geoScope.id}']`
            );
            if (active2) {
              active2.className += " decidimGeo__drawerHeader__listItem--active";
              container.scrollBy(active2.getBoundingClientRect().left, 0);
            }
          } else {
            const [active2] = document.querySelectorAll(
              `.decidimGeo__drawerHeader__listItem[data-scope='all']`
            );
            if (active2) {
              active2.className += " decidimGeo__drawerHeader__listItem--active";
              container.scrollBy(active2.getBoundingClientRect().left, 0);
            }
          }
        }
      );
      const [active] = document.querySelectorAll(
        `.decidimGeo__drawerHeader__listItem[data-scope='all']`
      );
      if (active) active.className += " decidimGeo__drawerHeader__listItem--active";
      map.on("moveend", moveHandler);
      window.addEventListener(
        "resize",
        _.throttle(
          function() {
            setTimeout(function() {
              map.invalidateSize();
            }, 300);
          },
          128,
          { leading: false, trailing: true }
        )
      );
    } catch (e) {
      console.error(e);
      const { map, mapID } = configStore.getState();
      if (map == null ? void 0 : map.remove) {
        map.remove();
      }
      if (map == null ? void 0 : map.off) {
        map.off();
      }
      (_a = document.getElementById(mapID)) == null ? void 0 : _a.remove();
    }
  });
}
function main() {
  return __async(this, null, function* () {
    var smallScreen = window.matchMedia("(max-width: 49.9988em)");
    const isSmallScreen = !!smallScreen.matches;
    if (isSmallScreen) {
      registerMobile();
    }
    yield prepareLeaflet(isSmallScreen);
    yield fetchData();
    yield displayMap();
  });
}
window.addEventListener("load", function() {
  main().then(() => {
    console.log(
      `DecidimGeo: ready. Using Leaflet ${L.version} (global: ${window.L.version})`
    );
    pointStore.setState(() => ({ isInitialized: true }));
  }).catch((error) => {
    console.error("Decidim Geo: Can't initialize.");
    console.error(error);
  });
});
export default L;
